import { refreshUserInfo } from '@/api'
import { pickUserAvatarUrl } from '@/utils/pickUserAvatarUrl'
import { EventBus } from '@/eventBus'

/** 是否在 15 天登录有效期内 */
export function isSessionLoggedIn() {
  const user = localStorage.getItem('user')
  if (!user) return false
  try {
    const { loginTime } = JSON.parse(user)
    if (!loginTime) return false
    const active = new Date()
    active.setDate(active.getDate() - 15)
    return active < new Date(loginTime)
  } catch {
    return false
  }
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem('user')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function getStoredVips() {
  try {
    const raw = localStorage.getItem('vips')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function getStoredStatistic() {
  try {
    const raw = localStorage.getItem('statistic')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

/** 已登录用户的手机号（account / userinfo） */
export function getLoggedInPhone() {
  try {
    const account = JSON.parse(localStorage.getItem('account') || '{}')
    if (account.phoneNumber) return account.phoneNumber
  } catch {
    /* ignore */
  }
  try {
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || '{}')
    if (userinfo.phone) return userinfo.phone
  } catch {
    /* ignore */
  }
  return ''
}

/**
 * 将接口返回的用户数据写入 localStorage（与 Login 登录成功逻辑一致）
 * @param {boolean} renewLoginTime 新登录时为 true；刷新资料时保留原 loginTime
 */
export function applyUserDataToStorage(userData, phoneNumber, { renewLoginTime = false } = {}) {
  const avatarUrl = pickUserAvatarUrl(userData)
  let loginTime = new Date().toISOString()
  if (!renewLoginTime) {
    try {
      const prev = JSON.parse(localStorage.getItem('user') || '{}')
      if (prev.loginTime) {
        loginTime = typeof prev.loginTime === 'string'
          ? prev.loginTime
          : new Date(prev.loginTime).toISOString()
      }
    } catch {
      /* ignore */
    }
  }

  localStorage.setItem('account', JSON.stringify({ phoneNumber }))
  localStorage.setItem('user', JSON.stringify({
    nickName: userData.username,
    loginTime,
    ...(avatarUrl ? { avatarUrl } : {}),
  }))
  localStorage.setItem('vips', JSON.stringify({
    packageName: userData.vipVersion + '版会员',
    title: userData.vipVersion + '版会员',
    remainDays: userData.dayTime,
    expireTime: userData.endTime,
  }))
  localStorage.setItem('statistic', JSON.stringify({
    totalPoints: userData.points,
    totalSignIn: userData.check,
    totalInvite: userData.invite,
  }))
  localStorage.setItem('userinfo', JSON.stringify({
    username: userData.username,
    phone: userData.phone || phoneNumber,
    vipVersion: userData.vipVersion,
    dayTime: userData.dayTime,
    endTime: userData.endTime,
    points: userData.points,
    check: userData.check,
    invite: userData.invite,
    ...(avatarUrl ? { avatarUrl } : {}),
  }))
  EventBus.$emit('user-session-updated')
}

/** 清除本地登录态并通知各组件刷新 */
export function clearUserSession() {
  localStorage.removeItem('user')
  localStorage.removeItem('vips')
  localStorage.removeItem('userinfo')
  localStorage.removeItem('statistic')
  localStorage.removeItem('token')
  localStorage.removeItem('account')
  EventBus.$emit('user-session-updated')
}

/** 已登录时拉取最新用户资料（task_id=3）并更新本地缓存 */
export async function refreshUserSessionIfLoggedIn() {
  if (!isSessionLoggedIn()) return null
  const phone = getLoggedInPhone()
  if (!phone) return null
  try {
    const res = await refreshUserInfo(phone)
    if (res.success === true && res.data) {
      applyUserDataToStorage(res.data, phone)
      EventBus.$emit('user-session-updated')
      return res.data
    }
  } catch (e) {
    console.warn('刷新用户信息失败', e)
  }
  return null
}
